/* eslint-disable camelcase */
import { getSetting } from 'local/lib/settings';
import formatDate from 'local/lib/formatDate';
import ratings from 'local/test/ratings';

export const initialResult = {
	latency: {
		progress: 1,
		result: 0,
		started: false,
		completed: false,
	},
	download: {
		progress: 0,
		result: 0,
		started: false,
		completed: false,
	},
	upload: {
		progress: 0,
		result: 0,
		started: false,
		completed: false,
	},
};

export const data = {
	hashkey: getSetting('hash_key'),
	configuration: null,
	error: false,
	errno: null,
	iptype: 'ipv4',
	ipv4Supported: true,
	ipv6Supported: true,
	server: null,
	startRequested: false,
	currentTest: null,
	result: { ...initialResult },
	report: null,
	advancedSettingsOpen: false,
	network: null,
	mobnet: null,
	measurementInfo: null,
	provider: null,
	speed: null,
	operatorInfoMessage: null,
	operatorBadInfoMessage: null,

	// Accessors
	hasSubscription() {
		const { report } = this;
		return (
			report && report.subscription && report.subscription.status === 1
		);
	},

	getSpeedObject() {
		let speedObject = null;
		const { report } = this;
		let { provider, speed } = this;
		const { subscription, subscription_info } = report;

		if (subscription && subscription.status === 1) {
			provider = subscription.ispTypeId;
			speed = subscription.ispSpeedId;
		}

		if (subscription_info) {
			subscription_info.forEach((s) => {
				if (`${s.id}` === provider) {
					s.categories.forEach((category) => {
						if (`${category.value}` === speed) {
							speedObject = category;
						}
					});
				}
			});
		}

		return speedObject;
	},

	getConnectionTypeString() {
		const connectionType = this.hasSubscription()
			? this.report.subscription.ispSpeedName
			: null;

		if (connectionType) {
			return connectionType;
		}

		if (this.provider && this.speed) {
			const speedObject = this.getSpeedObject();

			if (speedObject) {
				return speedObject.description;
			}
		}

		return window.bredbandskollen.i18n.unknown;
	},

	getServerByUrl(hostname) {
		const server = this.configuration.servers.find((s) => {
			return s.url === hostname;
		});

		return server || null;
	},

	getServerNameByUrl(hostname) {
		const server = this.getServerByUrl(hostname);

		return server ? server.name : this.configuration.servers[0].name;
	},

	getOperator() {
		const { configuration, report } = this;
		const operator = configuration.ispname;

		if (!this.hasSubscription()) {
			return operator;
		}

		return report.subscription.ispOperator || operator;
	},

	getRating() {
		const speedObject = this.getSpeedObject();

		if (!speedObject) {
			return null;
		}

		const downloadSpeed = this.result.download.result * 1000;

		if (downloadSpeed < speedObject.acceptable) {
			return ratings.BAD;
		}

		if (downloadSpeed < speedObject.good) {
			return ratings.ACCEPTABLE;
		}

		return ratings.GOOD;
	},

	getResultSummary() {
		return {
			connectionType: this.getConnectionTypeString(),
			serverName: this.getServerNameByUrl(this.report.server),
			operator: this.getOperator(),
			date: formatDate(this.report.date),
		};
	},

	getServer() {
		const { server, configuration, iptype } = this;
		const supports = {
			ipv4: this.ipv4Supported,
			ipv6: this.ipv6Supported,
		};

		if (server && supports[server.type]) {
			return server;
		}

		return configuration.servers.find((s) => {
			return s.type === iptype && s.tlsport === 443;
		});
	},

	getCurrentSpeed() {
		if (!this.currentTest) {
			return 0;
		}

		return this.result[this.currentTest].result;
	},

	getProgress() {
		const { download, upload } = this.result;
		return ((download.progress + upload.progress) / 2) * 100;
	},
};
